<template>
  <v-dialog value="true" max-width="300" persistent>
    <v-snackbar
      :timeout="0"
      v-model="showEightRoomWarningSnackbar"
      color="#00AEEF"
      centered
      top
    >
      <p class="subtitle-1 mr-3">
        {{ $t("project.notification.project_size.eight_room_warning") }}
      </p>
    </v-snackbar>
    <v-snackbar
      :timeout="0"
      v-model="showFiftyRoomWarningSnackbar"
      color="#00AEEF"
      centered
      top
      class="extra-spacing"
    >
      <p class="subtitle-1 mr-3">
        {{ $t("project.notification.project_size.fifty_room_warning") }}
      </p>
    </v-snackbar>
    <v-card round style="background-color: #1a1a1a" class="pa-6" outlined>
      <div class="d-flex justify-center">
        <v-progress-circular indeterminate :size="70" width="1" />
      </div>
      <div class="caption mt-6" style="text-align: center">
        {{ $t("project_list.modal.generate_report.action") }}
      </div>
      <div
        v-if="minutesRemaining"
        class="caption mt-1"
        style="text-align: center"
      >
        {{
          $te("project_list.modal.generate_report.remaining", "dk")
            ? $t("project_list.modal.generate_report.remaining", {
                minutes: minutesRemaining,
              })
            : `${minutesRemaining} minutter tilbage`
        }}
      </div>
      <v-progress-linear :height="8" rounded :value="progress" class="mt-2" />
      <div class="d-flex justify-center">
        <niko-button
          class="mt-10"
          :text="$t('project_list.modal.buttons.cancel')"
          @onClick="cancelGeneration"
        />
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import NikoButton from "@/components/UI/NikoButton";
import { mapMutations, mapState } from "vuex";

export default {
  name: "niko-loader",
  components: {
    NikoButton,
  },
  data: () => ({
    progress: 0,
    interval: null,
    finishingInterval: null,
    minutesRemaining: null,
    showEightRoomWarningSnackbar: false,
    showFiftyRoomWarningSnackbar: false,
  }),
  computed: {
    ...mapState("projectStore", ["buildings"]),
    ...mapState("loaderStore", ["finishPdfProgress"]),
  },
  watch: {
    buildings() {
      if (this.buildings.length > 0) {
        let noOfImages = 0;
        this.buildings.forEach((building) => {
          building.floors.forEach((floor) => {
            floor.rooms.forEach((room) => {
              if (room.room_image_url) {
                noOfImages = noOfImages + room.illumination_tests.length;
              }
            });
          });
        });

        this.showEightRoomWarningSnackbar = noOfImages >= 8;
        this.showFiftyRoomWarningSnackbar = noOfImages >= 50;

        const seconds = noOfImages > 0 ? noOfImages * 2 : 10;
        if (seconds > 60) {
          this.minutesRemaining = Math.ceil(seconds / 60);
        }
        this.interval = setInterval(() => {
          this.progress = this.progress + 100 / (seconds * 10);
          if (seconds > 60) {
            this.minutesRemaining = Math.ceil(
              (((100 - this.progress) / 100) * seconds) / 60
            );
          }
          if (this.progress >= 75) {
            clearInterval(this.interval);
          }
        }, 100);
      }
    },
    finishPdfProgress() {
      if (this.finishPdfProgress) {
        clearInterval(this.interval);
        this.minutesRemaining = null;
        const left = 100 - this.progress;
        this.finishingInterval = setInterval(() => {
          this.progress = this.progress + left / 7;
        }, 100);
      }
    },
    destroyed() {
      clearInterval(this.finishingInterval);
      this.showEightRoomWarningSnackbar = false;
      this.showFiftyRoomWarningSnackbar = false;
    },
  },
  methods: {
    ...mapMutations("projectStore", ["setGeneratingPdf", "resetProjectState"]),
    ...mapMutations("loaderStore", ["setIsLoading", "setCancelPdfGeneration"]),
    ...mapMutations("buildingStore", ["resetBuildingState"]),
    ...mapMutations("floorStore", ["resetFloorState"]),
    cancelGeneration() {
      this.setGeneratingPdf(false);
      this.setIsLoading(false);
      this.resetProjectState();
      this.resetBuildingState();
      this.resetFloorState();
      this.setCancelPdfGeneration(true);
      this.showEightRoomWarningSnackbar = false;
      this.showFiftyRoomWarningSnackbar = false;
    },
  },
  created() {
    setTimeout(() => {
      this.progress = 2;
    }, 500);
  },
};
</script>
<style>
.extra-spacing {
  top: 80px !important;
}
</style>
